const constants = {
    baseUrl: 'https://reliquary.stone-fish.com'
}

export default constants
